export default {"src":"/_next/static/media/maestro.34f7dba0.svg","height":167,"width":291,"blurWidth":0,"blurHeight":0};